import { createStore } from '@aibees/shared/store';
import { CompanySearchItemsStoreData as StoreData } from './types';

const useCompanySearchItemsStore = createStore<StoreData>(
  'company-search-excluded',
  (set, get) => ({
    companySearchItems: [],
    setCompanySearchItems: (companySearchItems) => {
      if (typeof companySearchItems === 'function') {
        const currentItems = get().companySearchItems;
        const newItems = companySearchItems(currentItems);
        set({ companySearchItems: newItems });
      } else {
        set({ companySearchItems });
      }
    },
    lookalikeCompanySearchItems: [],
    setLookalikeCompanySearchItems: (lookalikeCompanySearchItems) =>
      set({ lookalikeCompanySearchItems }),
  })
);

export default useCompanySearchItemsStore;
